/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

/**
 * **A stored field read as text** (`#1481`). A document read back from the server is `unknown` until
 * it is checked, and `String()` over it renders an object as `[object Object]`, a value that reads as
 * the operator's own text. A string is itself, a finite number or a boolean is its text, and anything
 * else, absence included, is `fallback`.
 */
export function storedText(value: unknown, fallback = ''): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : fallback;
  if (typeof value === 'boolean') return String(value);
  return fallback;
}
